<template>
  <router-link :to="go_to()" class="bank_payment link">
    <tr>
      <td :data-label="translate('bank_payment.date')">
        {{ bank_payment.date }}
      </td>
      <td :data-label="translate('bank_payment.sum')">
        {{ bank_payment.sum / 100 }}
      </td>
      <td :data-label="translate('bank_payment.inn')">
        {{ bank_payment.inn }}
      </td>
      <td :data-label="translate('bank_payment.ur_name')">
        {{ bank_payment.ur_name }}
      </td>
      <td :data-label="translate('bank_payment.client_name')">
        {{ bank_payment.client_name }}
      </td>
      <td :data-label="translate('bank_payment.ts_create')">
        {{ get_date(bank_payment.ts_create) }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'BankPaymentListItem',
  components: {
  },
  props: ["bank_payment"],
  data () {
    return {
    }
  },
  methods: {
    go_to() {
      return { path: '/bank_payment/' + this.bank_payment.id }
    }
  }
}
</script>

<style lang="scss" scoped>
.bank_payment{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    vertical-align: middle;
  }
}
</style>
